import { render, staticRenderFns } from "./MainPrograms.vue?vue&type=template&id=5fc3f815&"
import script from "./MainPrograms.vue?vue&type=script&lang=js&"
export * from "./MainPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports